import { motion, useReducedMotion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduce ? false : { opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
};

export const SectionHeader = ({ eyebrow, title, align = "left", children }) => (
  <div className={align === "center" ? "text-center" : "text-left"}>
    <Reveal>
      <span className="eyebrow" data-testid={`${eyebrow.toLowerCase().replace(/[^a-z]+/g, "-")}-eyebrow`}>
        {eyebrow}
      </span>
      <span className={`gold-rule mt-5 ${align === "center" ? "mx-auto" : ""}`} aria-hidden="true" />
      <h2 className="mt-6 font-serif text-4xl font-medium leading-tight tracking-tight text-white md:text-5xl">
        {title}
      </h2>
      {children && (
        <p className={`mt-6 max-w-2xl text-base leading-relaxed text-gray-400 md:text-lg ${align === "center" ? "mx-auto" : ""}`}>
          {children}
        </p>
      )}
    </Reveal>
  </div>
);
